import styled from "styled-components";

const ReceiptMessageText = styled.p`
	margin: 0;
	max-width: 100%;
	font-size: 13px;
	line-height: 18px;
	color: rgba(33, 51, 63, 0.85);
	word-break: break-word;
	overflow-wrap: anywhere;
	white-space: pre-wrap;
`;

export default ReceiptMessageText;
